/* eslint-disable react/no-danger */
import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
//uuid package is not availabe on packahe.json
// import { v4 as uuidv4 } from 'uuid';
import makeRequest from 'utils/makeRequest';
import Link from 'components/Link';
import AffiliateCard from './AffiliateCard';
// eslint-disable-next-line no-unused-vars
import s from './AffiliateWidget.scss';

const SeudoScrollWindow = () => {
  if (typeof window !== 'undefined') {
    //triggering window scroll event to show lazy loaded images on carousel next click
    window.scrollTo(window.scrollX, window.scrollY - 1);
    window.scrollTo(window.scrollX, window.scrollY + 1);
  }
};

class AffiliateWidgetMain extends React.Component {
  constructor(props) {
    super();
    this.state = {
      affiliateData: null,
      slidesToShow: props.slidesToShow || 3.5,
      slidesToScroll: props.slidesToScroll || 3,
      gutterAdsShown: false,
    };
  }

  fetchData = () => {
    const { url } = this.props;
    makeRequest
      .get(url, { isMobile: this.props.isWapView })
      .then(data => {
        if (data && data.data) {
          this.setState({ affiliateData: data.data });
        } else {
          this.handleDataError();
        }
      })
      .catch(err => this.handleDataError(err));
  };

  // checkForUniqueUserID = () => {
  //   if (typeof window !== 'undefined') {
  //     //first get the ssoid
  //     let uuid = window.localStorage.getItem('tas_uuid');
  //     if (!uuid) {
  //       uuid = uuidv4();
  //     }
  //     //set the unique id in localstorage
  //     window.localStorage.setItem('tas_uuid', uuid);
  //     this.setState({ uuid });
  //   }
  // };

  componentDidMount() {
    this.fetchData();
    // This is used for Tracking amazon product
    // this.checkForUniqueUserID();
  }

  handleDataError() {
    this.props.noDataCallBack();
  }
  getProductRenderList = (widgetData, tagData, gaData) => {
    const renderListArray = [];
    const lengthToShow = this.props.isWapView ? 5 : 10;
    const { productList } = widgetData;
    for (let i = 0; i < lengthToShow; i += 1) {
      if (productList instanceof Array && productList[i]) {
        renderListArray.push(
          <AffiliateCard
            {...productList[i]}
            key={i}
            tagData={tagData}
            gaData={gaData}
          />,
        );
      }
    }
    return renderListArray;
  };

  render() {
    const widgetData = this.state.affiliateData;
    const { gaData } = this.props;

    if (
      !widgetData ||
      !(
        widgetData.productList instanceof Array &&
        widgetData.productList.length > 0
      )
    ) {
      return null;
    }
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: this.state.slidesToShow,
      slidesToScroll: this.state.slidesToScroll,
      lazyLoad: true,
      beforeChange: SeudoScrollWindow,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const tagData = this.props.isWapView
      ? widgetData.tag && widgetData.tag.wap
      : widgetData.tag && widgetData.tag.web;
    const moreLink = `${widgetData.viewMoreUrl}?tag=${tagData}`;

    return (
      <div
        className={`${s[this.props.classvalue]} ${
          this.state.gutterAdsShown ? 'gutterAds' : ''
        }`}
      >
        <div className={`${s.header_affiliate} ${this.props.classheader}`}>
          <Link target="_blank" to={moreLink} disableClick>
            {/* {widgetData.viewMoreText} */}
            <h2>Recommended Deals</h2>
          </Link>
        </div>
        <div className={`${s.amazon_affiliate_box} ${this.props.classvalue}`}>
          {this.props.isWapView ? (
            <div className={s.m_affiliate_cards}>
              {this.getProductRenderList(widgetData, tagData, gaData)}
            </div>
          ) : (
            <Slider {...settings}>
              {this.getProductRenderList(widgetData, tagData, gaData)}
            </Slider>
          )}
        </div>
      </div>
    );
  }
}

AffiliateWidgetMain.propTypes = {
  url: PropTypes.string.isRequired,
  isWapView: PropTypes.bool.isRequired,
  classvalue: PropTypes.string,
  classheader: PropTypes.string,
  notLazyLoadImages: PropTypes.bool,
  slidesToShow: PropTypes.number,
  slidesToScroll: PropTypes.number,
  noDataCallBack: PropTypes.func,
};

AffiliateWidgetMain.defaultProps = {
  classvalue: '',
  classheader: '',
  notLazyLoadImages: false,
  slidesToShow: undefined,
  slidesToScroll: undefined,
  noDataCallBack: () => {},
};

export default AffiliateWidgetMain;
